<template lang="pug">
section.validacao-territorio
    BaseHeader#cadastrar-territorio(
        :titulo='this.resumoTerritorio.nome',
        :voltarPara='true'
    )

    .view-container-base-header
        .container-view-validacao
            .container-content
                .container-resumo
                    h1.titulo {{ $t('mensagens.territorio.territorioArgentina.resumoTerritorio') }}
                    .content
                        h2.titulo-secao {{ $t('mensagens.territorio.territorioArgentina.informacaoAgricola') }}
                        .container-box
                            .box
                                strong {{ $t('mensagens.territorio.territorioArgentina.cultura') }}
                                span {{ pegarInfoCultivo(this.resumoTerritorio) }}
                            .box
                                strong {{ $t('mensagens.territorio.territorioArgentina.area') }}
                                span {{ verificarValorLabel(this.resumoTerritorio?.areaHa.toFixed(3)) }}
                            .box
                                strong {{ $t('mensagens.territorio.territorioArgentina.produtividade') }}
                                span {{ pegarInfoProdutividade(this.resumoTerritorio) }}
                    .content
                        h2.titulo-secao {{ $t('mensagens.territorio.territorioArgentina.locacalizacao') }}
                        .container-box
                            .box
                                strong CUIT
                                span {{ formatarCuit(this.resumoTerritorio?.cuit) }}
                            .box
                                strong Província
                                span {{ verificarValorLabel(this.resumoTerritorio?.provincia) }}
                            .box
                                strong Renspa
                                span {{ formatarRenspa(this.resumoTerritorio?.renspa) }}
                    .content
                        h2.titulo-secao {{ $t('mensagens.territorio.territorioArgentina.dadosProdutor') }}
                        .container-box
                            .box
                                strong {{ $t('mensagens.territorio.territorioArgentina.nomeProdutor') }}
                                span {{ verificarValorLabel(this.resumoTerritorio?.representantes[0]?.nomeRazaoSocial) }}
                            .box
                                strong CUIT
                                span {{ formatarCuit(this.resumoTerritorio?.representantes[0]?.cpfCnpj) }}

                .arquivos-enviados(
                    v-if='this.resumoTerritorio.arquivosTerritorio.length > 0'
                )
                    h1.titulo {{ $t('mensagens.territorio.territorioArgentina.arquivosEnviados') }}
                    .container-arquivos
                        h1.sub-titulo {{ $t('mensagens.territorio.territorioArgentina.arquivosSubidos') }}
                        .box-arquivo(
                            v-for='arquivo in this.resumoTerritorio.arquivosTerritorio'
                        )
                            strong {{ $t('mensagens.comuns.nome') }}: {{ limitarTexto(arquivo.nomeArquivo) }}
                            strong.data {{ $t('mensagens.territorio.territorioArgentina.fechaCarga') }}: {{ arquivo.dataUpload }}
                            .box-buttons
                                a(
                                    :href='arquivo.urlDownload',
                                    target='_blank',
                                    rel='noopener noreferrer'
                                )
                                    i.el-icon-view
                                button(@click='downloadArquivo(arquivo.id)')
                                    i.el-icon-download

                //- .container-diagnostico
                //-     h1.titulo {{ $t('mensagens.territorio.territorioArgentina.analiseSocio') }}

                //-     .content
                //-         h2.titulo-secao {{ $t('mensagens.territorio.territorioArgentina.informacaoGearal') }}
                //-         .container-box
                //-             .box
                //-                 strong {{ $t('mensagens.territorio.territorioArgentina.areaInformacao') }}
                //-                 span {{ resumoTerritorio.informacaoGeral.area }}
                //-             .box
                //-                 strong {{ $t('mensagens.territorio.territorioArgentina.bioma') }}
                //-                 span {{ resumoTerritorio.informacaoGeral.bioma }}
                //-             .box
                //-                 strong {{ $t('mensagens.territorio.territorioArgentina.fronteira') }}
                //-                 span {{ resumoTerritorio.informacaoGeral.fronteira }}
                //-             .box
                //-                 strong {{ $t('mensagens.territorio.territorioArgentina.moduloFiscal') }}
                //-                 span {{ resumoTerritorio.informacaoGeral.moduloFiscal }}
                //-             .box
                //-                 strong {{ $t('mensagens.territorio.territorioArgentina.situacao') }}
                //-                 span {{ resumoTerritorio.informacaoGeral.situacao }}
                //-             .box
                //-                 strong {{ $t('mensagens.territorio.territorioArgentina.informe') }}
                //-                 span {{ resumoTerritorio.informacaoGeral.informe }}

                //-     h1.sub-titulo Análise
                //-     .analise-container-inicial(v-for='diagnostico in diagnosticos', v-if="!diagnosticosActive && !camadaActive")
                //-         .diagnostico-titulo
                //-             strong.titulo-diagnostico {{ diagnostico.camada.sigla }}
                //-             strong.inconformidades
                //-                 | {{ $t('mensagens.territorio.territorioArgentina.inconformidades') }}:
                //-                 span 01

                //-         span.arrow(@click="handleDiagnosticoActive(diagnostico.classificacao)")
                //-             i.mdi(class="mdi-chevron-right")

                //-     .analise-container-secundario(v-if="diagnosticosActive && !camadaActive")
                //-         .titulo-analise-secundaria
                //-             button(@click='handleDiagnosticoActive(diagnosticosActive.classificacao)')
                //-                 i.mdi(class="mdi-arrow-left")
                //-             h1.titulo {{ diagnosticosActive[0].classificacao }}

                //-         .conteudo-analise-secundaria(v-for='diagnosticoActive in diagnosticosActive')
                //-             strong {{ diagnosticoActive.camada.sigla }}
                //-             span {{ diagnosticoActive.inconformidades }}
                //-             button.arrow(@click="handleCamadaActive(diagnosticoActive.camada.id)")
                //-                 i.mdi(class="mdi-chevron-right")

                //-     .analise-container-terciarios(v-if="diagnosticosActive && camadaActive")
                //-         .titulo-analise-terciaria
                //-             button(@click='handleCamadaActive(camadaActive.id)')
                //-                 i.mdi(class="mdi-arrow-left")
                //-             h1.titulo {{ camadaActive.sigla }}

                //-         .conteudo-analise-terciaria
                //-             .box
                //-                 strong {{ $t('mensagens.territorio.territorioArgentina.tipo') }}:
                //-                 span {{ camadaActive.tipo }}
                //-             .box
                //-                 strong {{ $t('mensagens.territorio.territorioArgentina.nome') }}:
                //-                 span {{ camadaActive.nome }}
                //-             .box
                //-                 strong {{ $t('mensagens.territorio.territorioArgentina.codigo') }}:
                //-                 span {{ camadaActive.codigo }}
                //-             .box
                //-                 strong {{ $t('mensagens.territorio.territorioArgentina.areaInformacao') }}:
                //-                 span {{ camadaActive.area }}
                //-             .box
                //-                 strong {{ $t('mensagens.territorio.territorioArgentina.percentualSobreposicao') }}:
                //-                 span {{ camadaActive.percentual }}

            .mapa-view-argentina
                Mapa(
                    ref='mapaAR',
                    :mapLayersConfigs='layersMaps',
                    :mapConfig='mapConfig',
                    :height='"100%"',
                    :idMapa='"mapaAnaliseEleigibilidadeResumo"'
                )

        .botoes-territorio
            button.reprovar(
                @click='closeModalNotificacao',
                :disabled='this.resumoTerritorio.aprovado !== null'
            ) Reprovar
            button.aprovar(
                @click='aprovarTerritorio',
                :disabled='this.resumoTerritorio.aprovado !== null'
            ) Aprovar

        ModalTerritorioAdicionadoAR(
            :show='showModalTerritorioAdicionado',
            @close='closeModalTerritotorioAdicionado'
        )
        ModalNotificacaoAR(
            :show='showModalNotificacao',
            @close='closeModalNotificacao',
            :idTerritorio='this.idTerritorio',
            @reprovar='reprovarTerritorio'
        )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import Mapa from '@/components/MapaLeaflet.vue';
import formatters from '@/utils/formatters';
import territorioService from '@/services/TerritorioService';
import ModalTerritorioAdicionadoAR from '@/components/territorio/ModalTerritorioAdicionadoAR';
import ModalNotificacaoAR from '@/components/territorio/ModalNotificacaoAR';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';

export default {
    name: 'VizualizarTerritorioValidacaoAR',
    components: {
        BaseHeader,
        Mapa,
        ModalTerritorioAdicionadoAR,
        ModalNotificacaoAR
    },

    data() {
        return {
            idTerritorio: undefined,
            showModalTerritorioAdicionado: false,
            showModalNotificacao: false,
            resumoTerritorio: [],
            diagnosticos: [],
            diagnosticosActive: null,
            camadaActive: null,
            refMapa: null,
            layersMaps: [],
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true,
                    bufferControl: false
                },
                inspecionar: false,
                diagnostico: false
            }
        };
    },
    mounted() {
        const idTerritorio = this.$route.params.idTerritorio;
        this.idTerritorio = idTerritorio;
        this.fetchInformationsTerritory();
    },

    methods: {
        resetTerritorio() {
            this.$v.$reset();
            this.resumoTerritorio = {};
            this.diagnosticos = {};
        },

        async fetchInformationsTerritory() {
            const { data } =
                await territorioService.vizualizarTerritorioPendente(
                    this.idTerritorio
                );
            this.resumoTerritorio = data;
            await this.mostrarTerritorioNoMapa();
            // this.diagnosticos = fakeInformation.diagnostico.diagnosticoSocioambiental.diagnosticoGeometria;
        },

        handleDiagnosticoActive(classificacao) {
            const diagnosticoIsActive =
                this.diagnosticosActive?.classificacao === classificacao;
            if (!diagnosticoIsActive) {
                const diagnosticoSelected = this.diagnosticos.filter(
                    diagnostico => diagnostico.classificacao === classificacao
                );
                this.diagnosticosActive = diagnosticoSelected;
            } else {
                this.diagnosticosActive = null;
            }
        },

        handleCamadaActive(idCamada) {
            const camadaIsActive = this.camadaActive?.id === idCamada;
            if (!camadaIsActive) {
                const camadaSelected = this.diagnosticosActive?.find(
                    diagnostico => diagnostico.camada.id === idCamada
                );
                this.camadaActive = camadaSelected.camada;
            } else {
                this.camadaActive = null;
            }
        },

        mostrarTerritorioNoMapa() {
            this.refMapa = this.$refs['mapaAR'];

            this.layersMaps = [];

            const geoJson = this.resumoTerritorio.geometria;

            let layerTerritorio = {
                style: getEstiloGeometria('area'),
                name: 'Território analisado',
                geoJson: geoJson
            };

            this.layersMaps.push(layerTerritorio);

            this.refMapa.aplicarZoomGeoJson(geoJson);
        },

        async aprovarTerritorio() {
            try {
                await territorioService.aprovarOuReprovarTerritorio(
                    '',
                    true,
                    JSON.parse(this.idTerritorio)
                );
                await this.fetchInformationsTerritory();
                this.showModalTerritorioAdicionado = true;
            } catch (error) {
                // eslint-disable-next-line no-console
                console.log(error);
            }
        },

        async reprovarTerritorio(mensagemReprovacao, _) {
            try {
                await territorioService.aprovarOuReprovarTerritorio(
                    mensagemReprovacao,
                    false,
                    JSON.parse(this.idTerritorio)
                );
                await this.fetchInformationsTerritory();
            } catch (error) {
                // eslint-disable-next-line no-console
                console.log(error);
            }
        },

        closeModalTerritotorioAdicionado() {
            this.showModalTerritorioAdicionado = false;
        },

        closeModalNotificacao() {
            this.showModalNotificacao = !this.showModalNotificacao;
        },

        async downloadArquivo(idArquivo) {
            try {
                const response = await territorioService.downloadArquivo(
                    idArquivo
                );

                const contentDisposition =
                    response.headers['content-disposition'];
                const contentType = response.headers['content-type'];

                let fileName = 'arquivo_baixado';
                if (
                    contentDisposition &&
                    contentDisposition.includes('filename=')
                ) {
                    fileName = contentDisposition
                        .split('filename=')[1]
                        .split(';')[0]
                        .replace(/['"]/g, '');
                }

                const blob = new Blob([response.data], { type: contentType });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = fileName;

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                window.URL.revokeObjectURL(url);

                this.$notify.success({
                    message: this.$t('mensagens.certificado.sucessDownload')
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.certificado.erroDownload')
                });
            }
        },

        formatarCuit(cuit) {
            return formatters.formatarCuit(cuit);
        },

        formatarRenspa(renspa) {
            if (!renspa) return '-';
            if (renspa.length !== 13) return renspa;
            return `${renspa.slice(0, 2)}.${renspa.slice(2, 5)}.${renspa.slice(
                5,
                6
            )}.${renspa.slice(6, 11)}/${renspa.slice(11)}`;
        },

        limitarTexto(texto) {
            const limite = 30;
            if (texto.length <= limite) return texto;
            return texto.slice(0, limite) + '...';
        },
        pegarInfoCultivo(territorio) {
            return territorio.informacaoAgricolaPY.map(x => x.nome).join(',');
        },
        pegarInfoProdutividade(territorio) {
            return territorio.informacaoAgricolaPY
                .map(x => x.produtividade)
                .join(',');
        },

        verificarValorLabel(valor) {
            if (valor) {
                return valor;
            }

            return '-';
        }
    }
};
</script>

<style lang="scss" scoped>
.validacao-territorio {
    .view-container-base-header {
        display: flex;
        flex-direction: column;
        .container-view-validacao {
            width: 100%;
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 16px;
            .container-content {
                width: 100%;
                display: flex;
                flex-direction: column;
                gap: 10px;
                .container-resumo {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    gap: 15px;
                    padding: 10px 16px 30px 16px;
                    background: white;
                    border-radius: 5px;
                    .titulo {
                        font-size: 18px;
                        font-family: Roboto;
                        font-weight: 500;
                        color: #3b3b3b;
                        margin-bottom: 10px;
                    }
                    .content {
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                        .titulo-secao {
                            font-size: 16px;
                            font-family: Roboto;
                            font-weight: 500;
                            color: #3b3b3b;
                        }
                        .container-box {
                            width: 100%;
                            display: grid;
                            grid-template-columns: repeat(3, 1fr);
                            gap: 10px;
                            .box {
                                width: 100%;
                                display: flex;
                                flex-direction: column;
                                gap: 5px;
                                strong {
                                    font-size: 14px;
                                    font-weight: 400;
                                    font-family: Roboto;
                                    color: #3b3b3b;
                                }
                                span {
                                    font-size: 14px;
                                    font-weight: 500;
                                    font-family: Roboto;
                                    color: #3b3b3b;
                                }
                            }
                        }
                    }
                }
                .container-diagnostico {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    gap: 15px;
                    background: white;
                    border-radius: 5px;
                    padding: 10px 16px;
                    .titulo {
                        font-size: 18px;
                        font-family: Roboto;
                        font-weight: 500;
                        color: #3b3b3b;
                    }
                    .sub-titulo {
                        font-size: 14px;
                        font-family: Roboto;
                        font-weight: 500;
                        color: #3b3b3b;
                    }
                    .content {
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                        padding-bottom: 4px;
                        border-bottom: 1px solid #bebebe;
                        .titulo-secao {
                            font-size: 14px;
                            font-family: Roboto;
                            font-weight: 500;
                            color: #3b3b3b;
                        }
                        .container-box {
                            width: 100%;
                            display: grid;
                            grid-template-columns: repeat(3, 1fr);
                            gap: 10px;
                            .box {
                                width: 100%;
                                display: flex;
                                flex-direction: column;
                                gap: 5px;
                                strong {
                                    font-size: 14px;
                                    font-weight: 400;
                                    font-family: Roboto;
                                    color: #3b3b3b;
                                }
                                span {
                                    font-size: 14px;
                                    font-weight: 500;
                                    font-family: Roboto;
                                    color: #3b3b3b;
                                }
                            }
                        }
                    }
                    .analise-container-inicial {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        border-bottom: 1px solid #ccc;
                        padding-bottom: 4px;
                        .diagnostico-titulo {
                            display: flex;
                            flex-direction: column;
                            .titulo-diagnostico {
                                font-size: 14px;
                                font-family: Roboto;
                                font-weight: 500;
                                color: #3b3b3b;
                            }
                            .inconformidades {
                                font-size: 12px;
                                font-family: Roboto;
                                font-weight: 400;
                                color: #3b3b3b;
                                span {
                                    margin-left: 4px;
                                    font-size: 12px;
                                    font-family: Roboto;
                                    font-weight: 700;
                                    color: green;
                                }
                            }
                        }
                        .arrow {
                            cursor: pointer;
                        }
                    }
                    .analise-container-secundario {
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        gap: 15px;
                        padding-bottom: 8px;
                        .titulo-analise-secundaria {
                            display: flex;
                            align-items: center;
                            gap: 8px;
                            border-bottom: 1px solid #ccc;
                            button {
                                background: unset;
                                border: 0;
                                padding: 0;
                                color: #183b57;
                                font-size: 14px;
                                cursor: pointer;
                            }
                            h1 {
                                font-size: 14px;
                                color: #183b57;
                            }
                        }
                        .conteudo-analise-secundaria {
                            width: 100%;
                            display: flex;
                            align-items: center;
                            gap: 8px;
                            strong {
                                font-family: Roboto;
                                font-size: 14px;
                                font-weight: 400;
                                color: #3b3b3b;
                            }
                            span {
                                background: #fdf7e8;
                                border-radius: 100%;
                                padding: 2px 7px;
                                color: #f88342;
                                font-weight: 500;
                                font-size: 10px;
                                font-family: Roboto;
                            }
                            .arrow {
                                background: unset;
                                border: 0;
                                padding: 0;
                                font-size: 14px;
                                margin-left: auto;
                                cursor: pointer;
                            }
                        }
                    }
                    .analise-container-terciarios {
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        gap: 15px;
                        padding-bottom: 8px;
                        .titulo-analise-terciaria {
                            display: flex;
                            align-items: center;
                            gap: 8px;
                            border-bottom: 1px solid #ccc;
                            button {
                                background: unset;
                                border: 0;
                                padding: 0;
                                color: #183b57;
                                font-size: 14px;
                                cursor: pointer;
                            }
                            h1 {
                                font-size: 14px;
                                color: #183b57;
                            }
                        }
                        .conteudo-analise-terciaria {
                            width: 100%;
                            display: flex;
                            flex-direction: column;
                            gap: 5px;
                            padding: 10px;
                            background-color: #fafafa;
                            border-radius: 5px;
                            .box {
                                display: flex;
                                align-items: center;
                                gap: 5px;
                                strong {
                                    font-family: Roboto;
                                    font-size: 14px;
                                    font-weight: 400;
                                    color: #3b3b3b;
                                }
                                span {
                                    font-family: Roboto;
                                    font-size: 14px;
                                    font-weight: 500;
                                    color: #3b3b3b;
                                }
                            }
                        }
                    }
                }
            }
            .mapa-view-argentina
                #mapa-leaflet
                #mapaAnaliseEleigibilidadeResumo {
                border-radius: 5px !important;
            }
        }
        .arquivos-enviados {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 8px;
            padding: 10px 16px 30px 16px;
            background: white;
            border-radius: 5px;
            margin-top: 10px;
            .titulo {
                font-weight: 500;
                font-size: 16px;
                color: #3b3b3b;
                font-family: Roboto;
            }
            .container-arquivos {
                width: 100%;
                display: flex;
                flex-direction: column;
                gap: 16px;
                .sub-titulo {
                    font-weight: 500;
                    font-size: 14px;
                    color: #3b3b3b;
                    font-family: Roboto;
                }
                .box-arquivo {
                    width: 100%;
                    display: grid;
                    grid-template-columns: 1fr 1fr 1fr;
                    align-items: center;
                    padding: 16px;
                    border: 1px solid #bebebe;
                    border-radius: 5px;
                    strong {
                        font-weight: 400;
                        font-size: 14px;
                        color: #3b3b3b;
                        font-family: Roboto;
                    }
                    .data {
                        margin: auto;
                    }
                    .box-buttons {
                        display: flex;
                        align-items: center;
                        margin-left: auto;
                        gap: 10px;
                        a,
                        button {
                            background: none;
                            border: 0;
                            padding: 0;
                            color: #1c1b1f;
                            cursor: pointer;
                            &:hover {
                                outline: none !important;
                            }
                        }
                    }
                }
            }
        }
        .botoes-territorio {
            margin-top: auto;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            gap: 15px;
            padding-top: 30px;
            .reprovar {
                background: transparent;
                border: 1px solid #dc362e;
                border-radius: 4px;
                padding: 8px 24px;
                font-size: 14px;
                font-family: Roboto;
                color: #dc362e;
                font-weight: 500;
            }
            .aprovar {
                background: #183b57;
                border: 0;
                border-radius: 4px;
                padding: 8px 24px;
                font-size: 14px;
                font-family: Roboto;
                color: white;
                font-weight: 500;
            }
        }
    }
}
</style>

<style lang="scss">
.mapa-view-argentina #mapa-leaflet #mapaAnaliseEleigibilidadeResumo {
    border-radius: 5px !important;
}
</style>
